export const angleToRadians = (angleInDeg) => (Math.PI / 180) * angleInDeg;